import React from 'react';
import PropTypes from 'prop-types';
import { Header } from "../Header";
import { FullBleed } from "../../media/FullBleed";
import { DEFAULT_BOTTOM_OFFSET } from "./constants";
export var Component = function Component(_ref) {
  var activeNavigationItemIndex = _ref.activeNavigationItemIndex,
      backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      bottomOffset = _ref.bottomOffset,
      children = _ref.children,
      className = _ref.className,
      headerLogoHref = _ref.headerLogoHref,
      headerLogoSize = _ref.headerLogoSize,
      headerLogoSizes = _ref.headerLogoSizes,
      headerLogoSrc = _ref.headerLogoSrc,
      headerLogoSrcSet = _ref.headerLogoSrcSet,
      headerLogoSubText = _ref.headerLogoSubText,
      headerLogoText = _ref.headerLogoText,
      headerNavigationItems = _ref.headerNavigationItems,
      headerPrimaryCTA = _ref.headerPrimaryCTA,
      isHeaderBackgroundFilled = _ref.isHeaderBackgroundFilled,
      placeholderBackgroundImageUrl = _ref.placeholderBackgroundImageUrl;
  return React.createElement(FullBleed, {
    bottomOffset: bottomOffset,
    className: className,
    hasGradient: true,
    imageHeight: backgroundImageHeight,
    imageUrl: backgroundImageUrl,
    imageWidth: backgroundImageWidth,
    placeholderImageUrl: placeholderBackgroundImageUrl,
    sizes: backgroundImageSizes,
    srcSet: backgroundImageSrcSet
  }, React.createElement(Header, {
    activeNavigationItemIndex: activeNavigationItemIndex,
    isBackgroundFilled: isHeaderBackgroundFilled,
    logoHref: headerLogoHref,
    logoSize: headerLogoSize,
    logoSizes: headerLogoSizes,
    logoSrc: headerLogoSrc,
    logoSrcSet: headerLogoSrcSet,
    logoSubText: headerLogoSubText,
    logoText: headerLogoText,
    navigationItems: headerNavigationItems,
    primaryCTA: headerPrimaryCTA
  }), children);
};
Component.displayName = 'Hero';
Component.defaultProps = {
  activeNavigationItemIndex: null,
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  bottomOffset: DEFAULT_BOTTOM_OFFSET,
  children: null,
  className: '',
  headerLogoHref: undefined,
  headerLogoSize: undefined,
  headerLogoSizes: undefined,
  headerLogoSrc: null,
  headerLogoSrcSet: undefined,
  headerLogoSubText: undefined,
  headerPrimaryCTA: null,
  isHeaderBackgroundFilled: false,
  placeholderBackgroundImageUrl: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activeNavigationItemIndex: PropTypes.number,
  backgroundImageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundImageSizes: PropTypes.string,
  backgroundImageSrcSet: PropTypes.string,
  backgroundImageUrl: PropTypes.string.isRequired,
  backgroundImageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottomOffset: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  headerLogoHref: PropTypes.string,
  headerLogoSize: PropTypes.oneOf(['medium', 'large', 'huge']),
  headerLogoSizes: PropTypes.string,
  headerLogoSrc: PropTypes.string,
  headerLogoSrcSet: PropTypes.string,
  headerLogoSubText: PropTypes.string,
  headerLogoText: PropTypes.string.isRequired,
  headerNavigationItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })),
    text: PropTypes.string.isRequired
  })).isRequired,
  headerPrimaryCTA: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  }),
  isHeaderBackgroundFilled: PropTypes.bool,
  placeholderBackgroundImageUrl: PropTypes.string
} : {};